import { render, staticRenderFns } from "./Assessment-list.vue?vue&type=template&id=ad050c78&scoped=true"
import script from "./Assessment-list.vue?vue&type=script&lang=js"
export * from "./Assessment-list.vue?vue&type=script&lang=js"
import style0 from "./Assessment-list.vue?vue&type=style&index=0&id=ad050c78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad050c78",
  null
  
)

export default component.exports